import React from 'react';
import { NavLink } from 'react-router-dom';
import { Nav, Navbar, NavDropdown } from 'react-bootstrap';
import useAuth from '../../hooks/useAuth';
import { Global } from '../../helpers/Global';
import 'bootstrap/dist/css/bootstrap.min.css';

export const NavigationBar = () => {
  const { auth } = useAuth();
  const rol = auth?.rol;
  const modulos = auth?.modulos || {};

  const esAdmin = rol === 'admin';
  const partesTrabajoActivo = Global.partes_trabajo === "si";
  const silControlActivo = Global.silcontrol === "si";
  const miCalendarioActivo = Global.mi_calendario === "si";

  const tieneModulo = (nombreModulo) => {
    if (esAdmin) return true;
    return modulos?.[nombreModulo] === true;
  };

  const getAvatarUrl = () => {
    if (!auth?.avatar_url) return null;
    return `${Global.url}${auth.avatar_url}`;
  };

  const getIniciales = () => {
    const nombre = (auth?.nombre || '').trim();
    const apellidos = (auth?.apellidos || '').trim();
    const n1 = nombre ? nombre.split(' ')[0][0] : '';
    const a1 = apellidos ? apellidos.split(' ')[0][0] : '';
    const combo = (n1 + a1).toUpperCase();
    if (combo) return combo;
    if (nombre) return nombre[0].toUpperCase();
    return '?';
  };

  const avatarUrl = getAvatarUrl();

  return (
    <Navbar expand="lg" className="navi">
      <Navbar.Toggle aria-controls="basic-navbar-nav" />
      <Navbar.Collapse id="basic-navbar-nav">
        <Nav className="menu">
          <Nav.Link className="item-menu item-nav" as={NavLink} to="inicio">Inicio</Nav.Link>

          <NavDropdown className="item-menu nav-dropdown" title="Jornadas" id="jornadas-dropdown">
            <NavDropdown.Item as={NavLink} to="jornada">Nueva</NavDropdown.Item>
            <NavDropdown.Item as={NavLink} to="misJornadas">Mis Jornadas</NavDropdown.Item>
            {tieneModulo('jornadas') && <NavDropdown.Item as={NavLink} to="listadoJornadas">Listado Completo</NavDropdown.Item>}
            {tieneModulo('jornadas') && <NavDropdown.Item as={NavLink} to="jornadasCentro">Jornadas por Centro</NavDropdown.Item>}
            {tieneModulo('jornadas') && <NavDropdown.Item as={NavLink} to="jornadasProceso">En proceso</NavDropdown.Item>}
            {tieneModulo('jornadas') && <NavDropdown.Item as={NavLink} to="crearJornadas">Inserción manual</NavDropdown.Item>}
            {tieneModulo('jornadas') && <NavDropdown.Item as={NavLink} to="finalizarJornadas">Finalización manual</NavDropdown.Item>}
          </NavDropdown>

          <NavDropdown className="item-menu nav-dropdown" title="Intervenciones" id="intervenciones-dropdown">
            <NavDropdown.Item as={NavLink} to="intervencion">Nueva</NavDropdown.Item>
            <NavDropdown.Item as={NavLink} to="misIntervenciones">Mis Intervenciones</NavDropdown.Item>
            {tieneModulo('intervenciones') && <NavDropdown.Item as={NavLink} to="listadoIntervenciones">Listado Completo</NavDropdown.Item>}
            {tieneModulo('intervenciones') && <NavDropdown.Item as={NavLink} to="interProceso">En proceso</NavDropdown.Item>}
            {tieneModulo('intervenciones') && <NavDropdown.Item as={NavLink} to="crearIntervencionManual">Inserción manual</NavDropdown.Item>}
            {tieneModulo('intervenciones') && <NavDropdown.Item as={NavLink} to="finalizarInterManual">Finalización manual</NavDropdown.Item>}
            {partesTrabajoActivo && tieneModulo('intervenciones') && <NavDropdown.Item as={NavLink} to="misPartesManuales">Mis Partes Manuales</NavDropdown.Item>}
            {partesTrabajoActivo && tieneModulo('intervenciones') && <NavDropdown.Item as={NavLink} to="listadoPartesManuales">Todos los Partes Manuales</NavDropdown.Item>}
            {!tieneModulo('clientes') && <NavDropdown.Item as={NavLink} to="centrosInfo">Centros</NavDropdown.Item>}
          </NavDropdown>

          {tieneModulo('calendario') && (
            <NavDropdown className="item-menu nav-dropdown" title="Calendario" id="calendario-dropdown">
              {miCalendarioActivo && <NavDropdown.Item as={NavLink} to="miCalendario">Mi Calendario</NavDropdown.Item>}
              <NavDropdown.Item as={NavLink} to="calendarioAdmin">Administrar</NavDropdown.Item>
              <NavDropdown.Item as={NavLink} to="crearPlantillaTurno">Nueva Plantilla</NavDropdown.Item>
              <NavDropdown.Item as={NavLink} to="plantillaTurnoAdmin">Plantillas</NavDropdown.Item>
              <NavDropdown.Item as={NavLink} to="global">Global</NavDropdown.Item>
            </NavDropdown>
          )}

          {tieneModulo('ordenes') && (
            <NavDropdown className="item-menu nav-dropdown" title="Órdenes" id="ordenes-dropdown">
              <NavDropdown.Item as={NavLink} to="crearOrden">Nueva</NavDropdown.Item>
              <NavDropdown.Item as={NavLink} to="ordenAdmin">Listado Completo</NavDropdown.Item>
            </NavDropdown>
          )}

          {tieneModulo('clientes') && (
            <NavDropdown className="item-menu nav-dropdown" title="Clientes" id="clientes-dropdown">
              <NavDropdown.Item as={NavLink} to="crearCliente">Nuevo</NavDropdown.Item>
              <NavDropdown.Item as={NavLink} to="clientesAdmin">Listado Completo</NavDropdown.Item>
              <NavDropdown.Item as={NavLink} to="centrosInfo">Centros</NavDropdown.Item>
            </NavDropdown>
          )}

          {tieneModulo('tareas') && (
            <NavDropdown className="item-menu nav-dropdown" title="Tareas" id="tareas-dropdown">
              <NavDropdown.Item as={NavLink} to="crearTarea">Nueva Tarea</NavDropdown.Item>
              <NavDropdown.Item as={NavLink} to="tableroPersonal">Mis Tareas</NavDropdown.Item>
              <NavDropdown.Item as={NavLink} to="tableroDepartamento">Tareas Departamento</NavDropdown.Item>
              <NavDropdown.Item as={NavLink} to="dashboard">Panel Resumen</NavDropdown.Item>
              <NavDropdown.Item as={NavLink} to="organigramaDepartamentos">Organigrama Departamentos</NavDropdown.Item>
            </NavDropdown>
          )}

          {tieneModulo('departamentos') && (
            <NavDropdown className="item-menu nav-dropdown" title="Departamentos" id="departamentos-dropdown">
              <NavDropdown.Item as={NavLink} to="crearDepartamento">Nuevo Departamento</NavDropdown.Item>
              <NavDropdown.Item as={NavLink} to="departamentosAdmin">Listado Departamentos</NavDropdown.Item>
              <NavDropdown.Item as={NavLink} to="organigramaDepartamentos">Organigrama Departamentos</NavDropdown.Item>
            </NavDropdown>
          )}

          {silControlActivo && tieneModulo('silcontrol') && (
            <NavDropdown className="item-menu nav-dropdown" title="SilControl" id="silcontrol-dropdown">
              <NavDropdown.Item as={NavLink} to="crearReporteSIL">Reporte</NavDropdown.Item>
              <NavDropdown.Item as={NavLink} to="panelControlSIL">Panel</NavDropdown.Item>
              {rol === "admin" && <NavDropdown.Item as={NavLink} to="gestionControlSIL">Gestión</NavDropdown.Item>}
            </NavDropdown>
          )}

          {tieneModulo('usuarios') && (
            <NavDropdown className="item-menu nav-dropdown" title="Usuarios" id="usuarios-dropdown">
              <NavDropdown.Item as={NavLink} to="crearUsuario">Nuevo</NavDropdown.Item>
              <NavDropdown.Item as={NavLink} to="usuariosAdmin">Listado Completo</NavDropdown.Item>
              <NavDropdown.Item as={NavLink} to="organigrama">Organigrama</NavDropdown.Item>
            </NavDropdown>
          )}

          {tieneModulo('logs') && (
            <NavDropdown className="item-menu nav-dropdown" title="Logs" id="logs-dropdown">
              <NavDropdown.Item as={NavLink} to="logs">Logs</NavDropdown.Item>
            </NavDropdown>
          )}
        </Nav>

        <Nav className="ms-auto">
          <NavDropdown
            className="item-menu nav-dropdown nav-user-dropdown"
            id="usuario-dropdown"
            title={
              <span className="nav-user-chip">
                <span className="avatar-navbar">
                  {avatarUrl ? (
                    <img src={avatarUrl} alt={auth?.nombre || 'Usuario'} />
                  ) : (
                    <span className="avatar-fallback-navbar">
                      {getIniciales()}
                    </span>
                  )}
                </span>
                <span className="nav-user-name">
                  {auth?.nombre || 'Usuario'}
                </span>
              </span>
            }
          >
            <NavDropdown.Item as={NavLink} to="misAlertas">Mis Alertas</NavDropdown.Item>
            <NavDropdown.Item as={NavLink} to="cambiarContrasena">Cambio de contraseña</NavDropdown.Item>
            <NavDropdown.Divider />
            <NavDropdown.Item as={NavLink} to="logout">Cerrar Sesión</NavDropdown.Item>
          </NavDropdown>
        </Nav>
      </Navbar.Collapse>
    </Navbar>
  );
};